export default function columnsFormat(columns: number | undefined): string {
    if (!!columns && !isNaN(columns)) {
        let num = '';

        for (let i = 0; i < columns; i++) {
            num += '1fr ';
        }

        return num;
    }

    return '';
};